// src/utils/costCalculator.js

// Fee Constants
export const baseFees = {
    file_opening: 250,
    entry_permit: 500,
    medical: 320,
    emirates_id: 380,
    visa_stamping: 520,
    status_change: 650,
  };
  
  export const attestationFees = {
    marriage: 420,
    birth: 420,
  };
  
  /**
   * Calculates the cost breakdown for a single dependent.
   * @param {Object} member - The dependent’s details (e.g., relation and location).
   * @param {number} index - The index of the member (to apply file opening fee for the first member only).
   * @param {boolean} includeAttestation - Flag to determine if attestation fees are included.
   * @returns {Object} The calculated fee breakdown for the member.
   */
  export function calculateMemberBreakdown(member, index, includeAttestation) {
    console.log(member,"members")
    const breakdown = {
      file_opening: index === 0 ? baseFees.file_opening : 0,
      entry_permit: member.location === 'uae' ? 1150 : baseFees.entry_permit,
      // If the location is 'outside', no status change fee is applied.
      status_change: member.location === 'outside' ? 0 : baseFees.status_change,
      // No medical fee for a child.
      medical: member.relation === 'child' ? 0 : baseFees.medical,
      visa_stamping: baseFees.visa_stamping,
      emirates_id: baseFees.emirates_id,
      attestation: 0,
    };
  
    if (includeAttestation) {
      if (member.relation === 'spouse') {
        breakdown.attestation += attestationFees.marriage;
      } else if (member.relation === 'child') {
        breakdown.attestation += attestationFees.birth;
      }
    }
  
    // Calculate the total cost for the member
    breakdown.total = Object.values(breakdown).reduce((sum, value) => sum + value, 0);
    return breakdown;
  }
  
  /**
   * Calculates the cost breakdown for an array of dependents.
   * @param {Array} dependentsData - An array of dependent objects.
   * @param {boolean} includeAttestation - Flag to determine if attestation fees are included.
   * @returns {Array} An array of fee breakdowns for each dependent.
   */
  export function calculateCostBreakdown(dependentsData, includeAttestation) {
    return dependentsData.map((member, index) =>
      calculateMemberBreakdown(member, index, includeAttestation)
    );
  }
  
  /**
   * Sums up the total fees from an array of cost breakdown objects.
   * @param {Array} costBreakdown - An array of fee breakdowns.
   * @returns {number} The grand total cost.
   */
  export function calculateGrandTotal(costBreakdown) {
    return costBreakdown.reduce((acc, member) => acc + member.total, 0);
  }
  